(function () {
  'use strict';

  function getYear() {
    // Prefer the globally exposed year (set in footer-js.liquid), fall back to attribute.
    if (typeof window !== 'undefined' && window.BOOKLY_CUSTOMER_CREATED_YEAR) {
      return String(window.BOOKLY_CUSTOMER_CREATED_YEAR);
    }
    var body = document.body;
    if (body && body.getAttribute) {
      var y = body.getAttribute('data-bookly-created-year');
      if (y) return String(y);
    }
    return '';
  }

  function setCreatedYears(root) {
    var year = getYear();
    if (!year) return;

    var scope = root && root.querySelectorAll ? root : document;
    var els = scope.querySelectorAll('.bookly-created-year');
    if (!els || !els.length) return;

    els.forEach(function (el) {
      // Only fill if empty (Liquid may already output it)
      if (!el.textContent || !el.textContent.trim()) {
        el.textContent = year;
      }
    });
  }

  function initObserver() {
    if (!('MutationObserver' in window)) return;

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          // If the node is or contains our target span(s), fill them.
          if (n.matches && n.matches('.bookly-created-year')) {
            setCreatedYears(n.parentNode || document);
          } else if (n.querySelector && n.querySelector('.bookly-created-year')) {
            setCreatedYears(n);
          }
        }
      }
    });

    obs.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setCreatedYears(document);
    initObserver();
  });
})();
